<script>
export const group = 'Bottom'
</script>

<script setup>
import AnimatedSkewedEllipsMaskWithEnergeticFrequencies from './shared/AnimatedSkewedEllipsMaskWithEnergeticFrequencies.vue'
import MicrophoneIcon from '../../../assets/icons/microphone.svg?url_encode'
const gsapTimeline = useGsapTimeline()

defineProps({
  item: Object,
})

const ellipsTimeline = ref(null)
const disappearTimeline = ref(null)

onMounted(() => {
  gsapTimeline({ name: 'VoiceMessageSmall' }).add(ellipsTimeline)
})

const { onDisappear } = useDisappearable()
onDisappear(async () => await gsapTimeline({ name: 'VoiceMessageSmall - Disappear' }).add(disappearTimeline.value()))
</script>

<template>
  <div class="absolute bottom-0 p-safe">
    <AnimatedSkewedEllipsMaskWithEnergeticFrequencies
      class="-mb-10 scale-50 origin-bottom-left"
      loopFrequencies
      :loopFrequenciesDelay="3"
      @timeline="ellipsTimeline = $event"
      @disappearTimeline="disappearTimeline = $event"
    >
      <div class="w-full h-full bg-q-cr-red-primary flex items-center justify-center">
        <img :src="MicrophoneIcon" class="w-24 h-24" />
      </div>
    </AnimatedSkewedEllipsMaskWithEnergeticFrequencies>
  </div>
</template>
